import Reports from './Reports/Routes';

export default [...Reports];